/**
 * مقصدِ کلیک روی یک اعلان، برای **وب**.
 *
 * دو قرینه‌ی هم‌خانواده دارد که هر سه باید هم‌داستان بمانند:
 *   • `linkOf` در supabase/functions/notify-push — همین نگاشت برای کلیکِ
 *     اعلانِ مرورگر، که چون در لبه است تست‌پذیر نیست. این‌جا همان منطق
 *     جایی نشسته که `npm test` می‌بیندش.
 *   • `notificationTarget` در apps/mobile/src/features/notifications —
 *     همان تصمیم برای مسیرهای expo-router (که `/(tabs)/…` دارند و tag_event
 *     را به کشفِ فیلترشده می‌برند، چون موبایل آن پارامتر را می‌فهمد).
 *
 * مقصد فقط از `data`ی سطر حدس زده می‌شود، نه از `kind` — همان دلیلِ
 * `linkOf`: تفکیک‌کننده خودِ شناسه‌هاست (خبرِ دوستی `friendship_id` دارد،
 * خبرِ برنامه `signal_id`، خبرِ تگ `event_id`).
 *
 * `null` یعنی «جایی برای رفتن نیست» — سطرِ کهنه‌ای که شناسه‌ای ندارد.
 * صفحه‌ی فهرست چنین سطری را غیرقابل‌کلیک نشان می‌دهد، نه اینکه به صفحه‌ی
 * اول پرت کند.
 */

const text = (value: unknown): string | null => {
  if (typeof value === 'string' && value.trim()) return value;
  if (typeof value === 'number' && Number.isFinite(value)) return String(value);
  return null;
};

export function notifWebTarget(data: Record<string, unknown> | null | undefined): string | null {
  const signalId = text(data?.signal_id);
  if (signalId) {
    // یادآورِ عکس (مایگریشن 0141) `tab: 'photos'` می‌فرستد — لمسش باید همان
    // سربرگ را باز کند، نه اینکه کاربر در «جزئیات» فرود بیاید و خودش بگردد.
    const tab = text(data?.tab);
    return `/signal/${encodeURIComponent(signalId)}`
      + (tab ? `?tab=${encodeURIComponent(tab)}` : '');
  }

  // وب هنوز پارامترِ friendshipId را نمی‌خواند؛ خودِ صفحه‌ی دوستان،
  // درخواست‌ها را بالای فهرست نشان می‌دهد و همان‌جا «جایی که باید» است.
  if (text(data?.friendship_id)) return '/friends';

  const eventId = text(data?.event_id);
  if (eventId) return `/event/${encodeURIComponent(eventId)}`;

  return null;
}
